import { list49200Sprint01 } from '../ActivityLists/AL49200Sprint01'
import { list49200Sprint02 } from '../ActivityLists/AL49200Sprint02'
import { tLab } from './SL00000Sprint00'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

import { se_2_1of4_PAaA, xyz_2_1of4 } from './SL44000Sprint02TTR'

// Software Systems Capstone (SSC) sprint 2 values.
const sprint = 2
const activityList = () => { return list49200Sprint02(sprint) }
const activityListPrevious = () => { return list49200Sprint01(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

const ssc_1_1of4 = () => { return xyz_2_1of4(se_2_1of4_PAaA, ics_2_2of4_PAaA, sprintAndActivityLists) }
// Session 2 of 4: Thursday
const ics_2_2of4_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		'Be prepared for Demos and Retrospectives',
		'Focus on reading “Computer Science Illuminated” The Big Picture and review chapter 1 lecture',
		'Be prepared for “Computer Science Illuminated” The Big Picture Breakout' ],
	'announcements':[
		'Reducing procrastination is on the agenda',
		'Does everyone know where to find the class recordings?'],
	'agenda':[
		`Sprint ${sprint} Planning Questions & Answers`,
		`Discussion Board ${sprint} as a scrum team`,
		'Confirm scrum team Demos for Next Class',
		'Prework for Next Class',
		'Lab' ],
}

const ssc_1_2of4 = () => { return [ renderCalendar, renderFinalExamTimes ] }
const ssc_1_3of4 = () => { return [ tLab ] }
const ssc_1_4of4 = () => { return [ renderCalendar, renderFinalExamTimes ] }

export const ssc_2_slidedeckTTR = [ ssc_1_1of4, ssc_1_2of4, ssc_1_3of4, ssc_1_4of4 ]